// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorPage_container__4VMfI","pageTitle":"ErrorPage_pageTitle__KA2Ly","info":"ErrorPage_info__6bEaF","link":"ErrorPage_link__CJwVC"};